export const build = { date:"2026-02-17.1228", stage:"alpha" }
